export const fareharborStyles = {
  mainHeading: { fontSize: "22px", fontWeight: "600", marginBottom: 2 },
  subHeading: { fontSize: "17px", fontWeight: "600" },
  mainText: { fontSize: "15px", fontWeight: "400" },
  smallText: { fontSize: "13px", fontWeight: "400" },
  smallHeading: { fontSize: "13px", fontWeight: "600" },
  mb10: { marginBottom: 1 },
  ml10: { marginLeft: 1 },
  singlePan: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    alignItems: "center",
  },
  btnStyle: {
    minWidth: { xs: "100%", sm: "300px" },
    marginY: 1,
  },
};
